<template>
	<div style="position: relative;width: 100%;">
		<div style="padding: 1.4% 2%;background-color: #fff;">
			<el-form :inline="true">
				<el-form-item label="创建时间">
					<!-- 
                      关键修改：
                      1. 添加 value-format="YYYY-MM-DD HH:mm:ss"
                         确保 v-model 绑定的是字符串数组，而非 Date 对象数组
                      2. 移除 :clearable="false" (可选)，建议允许用户清空
                    -->
					<el-date-picker 
						v-model="queryListForm.queryTime" 
						type="datetimerange" 
						range-separator="至" 
						start-placeholder="开始日期" 
						end-placeholder="结束日期"
						value-format="YYYY-MM-DD HH:mm:ss"
						:default-time="[new Date(2000, 1, 1, 0, 0, 0), new Date(2000, 1, 1, 23, 59, 59)]">
					</el-date-picker>
				</el-form-item>
				
				<el-form-item label="搜索内容">
					<el-input style="width: 15vw;position: relative;" @change="getOrderList()" v-model="queryListForm.q"
						clearable placeholder="支持运单号、姓名、电话、地址搜索" maxlength="20" show-word-limit type="text"></el-input>
				</el-form-item>
				<el-form-item>
					<el-button type="primary" @click="getOrderList()">查询</el-button>
				</el-form-item>
			</el-form>
		</div>
		
		<div style="margin-top: 1vh;background-color: #fff;padding: 2%;font-family: sans-serif;color: #444444;">
			<el-table :data="queryOrderList.orderList" height="74vh" style="z-index: 2;"
				:header-cell-style="{background:'#f4f4f5',color:'#3b3b3b','font-weight': 400}">
				<el-table-column prop="creationTime" label="创建时间" align="center" width="107"></el-table-column>
				<el-table-column prop="waybillNo" label="运单号" align="center">
					<template #default="scope">
						<div style="display: flex;align-items: center;">
							<div @click="waybillQueryPopup({cpCode: scope.row.cpCode,waybillNo: scope.row.waybillNo,phone: scope.row.sender.mobile})"
								style="color: #409EFF;cursor: pointer;">
								{{scope.row.waybillNo}}
							</div>
							<el-icon v-if="scope.row.waybillNo" @click="common.copy(scope.row.waybillNo)" style="left: 0.7em;"><CopyDocument /></el-icon>
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="orderStatusText" label="订单状态" align="center"></el-table-column>
				<el-table-column prop="waybillLatestStatusName" label="物流状态" align="center">
					<template #default="scope">
						<div v-if="scope.row.waybillLatestStatusName">{{scope.row.waybillLatestStatusName}}</div>
						<div v-else>未发出</div>
					</template>
				</el-table-column>
				<el-table-column prop="sender" label="发件信息" width="240" align="left" header-align="left">
					<template #default="scope">
						<div>
							{{scope.row.sender.name}}{{"&nbsp;&nbsp;"}}
							<span v-if="scope.row.sender.mobile">{{scope.row.sender.mobile}}</span>
							<span v-else>{{scope.row.sender.phone}}</span>
						</div>
						<div style="overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:1; ">
							{{scope.row.sender.provinceName}}{{scope.row.sender.cityName}}{{scope.row.sender.districtName}}{{scope.row.sender.address}}
						</div>
					</template>
				</el-table-column>
				<el-table-column prop="recipient" label="收件信息" width="240" align="left" header-align="left">
					<template #default="scope">
						<div>
							{{scope.row.recipient.name}}{{"&nbsp;&nbsp;"}}
							<span v-if="scope.row.recipient.mobile">{{scope.row.recipient.mobile}}</span>
							<span v-else>{{scope.row.recipient.phone}}</span>
						</div>
						<div style="overflow:hidden; text-overflow:ellipsis;display:-webkit-box; -webkit-box-orient:vertical;-webkit-line-clamp:1; ">
							{{scope.row.recipient.provinceName}}{{scope.row.recipient.cityName}}{{scope.row.recipient.districtName}}{{scope.row.recipient.address}}
						</div>
					</template>
				</el-table-column>
				<el-table-column fixed="right" label="操作" align="center">
					<template #default="scope">
						<el-button @click="see(scope.row)" type="text">查看</el-button>
						<el-button v-if="scope.row.orderStatusCode == 'CREATE'"
							@click="waybillPrintPopup({orderContent:scope.row,isReprint:false})"
							type="text">打印</el-button>
						<el-button v-if="['GET_WAYBILL','PRINT'].includes(scope.row.orderStatusCode)"
							@click="waybillPrintPopup({orderContent:scope.row,isReprint:true})"
							type="text">重新打印</el-button>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination @size-change="handleSizeChange($event)" @current-change="handleCurrentChange($event)"
				:page-sizes="[10,50,100,200]" :total="queryOrderList.total" v-model:current-page="queryListForm.pages"
				v-model:page-size="queryListForm.pageSize"
				layout="total, sizes, prev, pager, next, jumper"></el-pagination>
		</div>

		<!--订单详情窗口-->
		<div v-if="order_info_window" class="order-info scroll-bar">
			<div @click="order_info_window=false"
				style="position: fixed;width: 100%;height: 100%;background-color: rgb(20 20 20);left: 0%;top: 0;opacity: 0.7;z-index: 6;">
			</div>
			<div
				style="position: fixed;width:60%;height: 85%;background-color: #ffffff;z-index: 7;top: 6%;left: 21%;border-radius: 0.3em;">
				<div @click="order_info_window=false"
					style="position: absolute;right: 2%;top: 1.6%;font-size: 1.4em;color: #7f8186;z-index: 2;">
					<i class="el-icon-close" style="font-size: 1.4rem;"></i>
				</div>
				<div class="scroll-bar"
					style="position: relative;width:92%;height: 90%;margin: 5% 0 1% 5%;overflow-y: auto;">
					<div>
						<div class="block-header">
							<div>订单信息</div>
						</div>
						<div class="block-data">
							<div class="block-data-row">
								<div class="row-name">运单号：</div>
								<div class="row-data">
									<span v-if="orderInfo.cpName && orderInfo.cpName!='未知品牌'"
										style="margin-right: 1rem;">{{orderInfo.cpName}}</span>
									<span @click="$commonFunction.toQueryWaybill(orderInfo.waybillNo)"
										v-if="orderInfo.waybillNo"
										style="cursor:pointer;color: #409EFF;margin-right: 1rem;">{{orderInfo.waybillNo}}</span>
									<span v-else>未获取</span>
									<span v-show="orderInfo.previewImageUrl"><a :href="orderInfo.previewImageUrl"
											target="_blank" style="color: #409EFF;text-decoration:none;">查看面单</a></span>
								</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">发件人：</div>
								<div class="row-data">
									{{orderInfo.sender.name}}{{"&nbsp;&nbsp;"}}{{orderInfo.sender.mobile}}{{orderInfo.sender.phone}}{{"&nbsp;&nbsp;"}}{{orderInfo.sender.provinceName}}{{orderInfo.sender.cityName}}{{orderInfo.sender.districtName}}{{orderInfo.sender.address}}
								</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">收件人：</div>
								<div class="row-data">
									{{orderInfo.recipient.name}}{{"&nbsp;&nbsp;"}}{{orderInfo.recipient.mobile}}{{orderInfo.recipient.phone}}{{"&nbsp;&nbsp;"}}{{orderInfo.recipient.provinceName}}{{orderInfo.recipient.cityName}}{{orderInfo.recipient.districtName}}{{orderInfo.recipient.address}}
								</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">物品名称：</div>
								<div v-if="orderInfo.goods.length>0" class="row-data">{{orderInfo.goods[0].name}}</div>
								<div v-else class="row-data">未定义</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">物品重量：</div>
								<div v-if="orderInfo.goods.length>0" class="row-data">
									<span>{{orderInfo.goods[0].weight}}</span>
									<span v-if="orderInfo.goods[0].weight">公斤</span>
								</div>
								<div v-else class="row-data">未定义</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">备注：</div>
								<div class="row-data">{{orderInfo.remark}}</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">实名采集：</div>
								<div class="row-data">暂不支持</div>
							</div>
						</div>
					</div>
					<div v-if="orderInfo.service.length>0">
						<el-divider></el-divider>
						<div class="block-header">
							<div>增值服务</div>
						</div>
						<div class="block-data">
						</div>
					</div>
					<div v-if="orderInfo.goodsImageList.length>0">
						<el-divider></el-divider>
						<div class="block-header">
							<div>包裹照片</div>
						</div>
						<div class="block-data">

						</div>
					</div>
					<div>
						<el-divider></el-divider>
						<div class="block-header">
							<div>其他信息</div>
						</div>
						<div class="block-data">
							<div class="block-data-row">
								<div class="row-name">订单状态：</div>
								<div class="row-data">{{orderInfo.orderStatusText}}</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">订单编号：</div>
								<div class="row-data">{{orderInfo.orderNo}}</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">创建时间：</div>
								<div class="row-data">{{orderInfo.creationTime}}</div>
							</div>
							<div class="block-data-row">
								<div class="row-name">订单来源：</div>
								<div class="row-data"></div>
							</div>
						</div>
					</div>
					<el-divider></el-divider>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	// Vue 3 中如果需要使用 dayjs 进行时间格式化，通常需要引入
	// Element Plus 内部依赖 dayjs，如果项目中未显式安装，可能需要 npm install dayjs
	import dayjs from 'dayjs'; 

	export default {
		data() {
			return {
				queryOrderList: {
					orderList: [],
					total: 0
				},

				order_info_window: false,
				orderInfo: {
					sender: {},
					recipient: {}
				},
				queryListForm: {
					waybillNo: "",
					q: "",
					queryTime: [], // 初始为空数组
					cpCode: "",
					pages: 1,
					pageSize: 10,
				},
				queryWindow: false
			}
		},
		created() {
			this.initDefaultTime();
			this.getOrderList();
		},
		methods: {
			// 初始化默认时间
			initDefaultTime() {
				try {
					// 使用 dayjs 获取最近30天的时间，并格式化为字符串
					// 这解决了手动拼接字符串可能出现的时区和格式错误问题
					const endDate = dayjs().endOf('day');
					const startDate = dayjs().subtract(30, 'day').startOf('day');

					this.queryListForm.queryTime = [
						startDate.format('YYYY-MM-DD HH:mm:ss'),
						endDate.format('YYYY-MM-DD HH:mm:ss')
					];
				} catch (e) {
					console.error("时间初始化失败", e);
					// 降级处理：如果 dayjs 不可用，使用原生 JS (注意时区问题)
					const now = new Date();
					const start = new Date(now.getTime() - 30 * 24 * 60 * 60 * 1000);
					
					const fmt = (d) => {
						const pad = (n) => n < 10 ? '0' + n : n;
						return `${d.getFullYear()}-${pad(d.getMonth()+1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
					};
					
					this.queryListForm.queryTime = [fmt(start), fmt(now)];
				}
			},
			
			// 分页
			handleSizeChange(size) {
				this.queryListForm.pageSize = size;
				this.getOrderList()
			},
			handleCurrentChange(pages) {
				this.queryListForm.pages = pages;
				this.getOrderList()
			},
			see(data) {
				if (data) {
					this.order_info_window = true;
					console.log(data);
					// 在 Vue 3 中，直接赋值给 reactive 对象的属性是响应式的
					// 但如果 orderInfo 是 ref，则需要 .value
					// 这里假设 orderInfo 是普通对象，Vue 3 会自动代理
					Object.assign(this.orderInfo, data);
				} else {
					this.$message.error('订单详情不存在');
				}
			},
			//获取订单列表
			getOrderList() {
				this.queryOrderList = [];
				console.log("查询参数:", this.queryListForm);
				this.apiService.post({
						modules: "getOrderList",
						content: this.queryListForm
					})
					.then((res) => {
						if (res.status) {
							this.queryOrderList = res.data;
							console.log(this.queryOrderList)
						}
					})
			},
			// 占位方法，防止报错
			waybillQueryPopup(params) {
				console.log("查询物流", params);
			},
			waybillPrintPopup(params) {
				console.log("打印面单", params);
			}
		}
	}
</script>

<style scoped>
	.order-info {
		font-family: sans-serif;
	}

	.order-info .block-header {
		font-weight: 600;
		margin-bottom: 1rem;
	}

	.order-info .block-data-row {
		display: flex;
		margin-top: 0.6rem;
	}

	.order-info .block-data-row .row-name {
		color: #8f8e8ef2;
		width: 10%;
		position: relative;
	}
	
	.scroll-bar::-webkit-scrollbar {
		width: 6px;
		height: 6px;
	}
	.scroll-bar::-webkit-scrollbar-thumb {
		background: #ccc;
		border-radius: 3px;
	}
</style>


